import { render, staticRenderFns } from "./MilestoneUpdateModal.vue?vue&type=template&id=7a2bc66a&"
import script from "./MilestoneUpdateModal.vue?vue&type=script&lang=js&"
export * from "./MilestoneUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports